import React, { useState } from "react";
import { FormGroup, Label, Input, Button, Row, Col } from "reactstrap";
import { Plus, Trash2, Clock, AlertCircle } from "react-feather";
import styles from "./WorkingHoursForm.module.scss";

const daysOfWeek = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];

const WorkingHoursForm = ({ key, businessType, workingHours, setWorkingHours }) => {
  const [newEntry, setNewEntry] = useState({ day: "", openAt: "", closedAt: "", isClosed: false });
  const [error, setError] = useState("");

  const handleNewEntryChange = (field, value) => {
    setNewEntry({ ...newEntry, [field]: value });
  };

  const addWorkingHour = () => {
    setError("");
    if (!newEntry.day) return setError("Please select a day.");
    if (!newEntry.isClosed && (!newEntry.openAt || !newEntry.closedAt))
      return setError("Please set opening and closing time.");
    if (workingHours.some((entry) => entry.day === newEntry.day))
      return setError("This day is already added.");

    setWorkingHours([...workingHours, newEntry]);
    setNewEntry({ day: "", openAt: "", closedAt: "", isClosed: false });
  };

  const removeWorkingHour = (index) => {
    const updatedHours = workingHours.filter((_, i) => i !== index);
    setWorkingHours(updatedHours);
  };

  return (
    <div className={styles.workingHoursContainer} key={key}>
      <h5 className={styles.sectionTitle}>{businessType.charAt(0).toUpperCase() + businessType.slice(1)} Working Hours</h5>
      {error && (
        <div className={styles.errorMessage}>
          <AlertCircle size={16} className={styles.errorIcon} /> {error}
        </div>
      )}
      <div className={styles.workingHoursForm}>
        <Row className={styles.inputRow}>
          <Col md={3}>
            <FormGroup className={styles.formGroup}>
              <Label>Day</Label>
              <Input
                type="select"
                value={newEntry.day}
                onChange={(e) => handleNewEntryChange("day", e.target.value)}
              >
                <option value="">Select Day</option>
                {daysOfWeek.map((day) => (
                  <option key={day} value={day}>
                    {day}
                  </option>
                ))}
              </Input>
            </FormGroup>
          </Col>
          <Col md={2} className={styles.checkboxContainer}>
            <input
              type="checkbox"
              checked={newEntry.isClosed}
              onChange={(e) => handleNewEntryChange("isClosed", e.target.checked)}
            />
            <label className={styles.closedLabel}>Closed</label>
          </Col>
          {!newEntry.isClosed && (
            <>
              <Col md={3}>
                <FormGroup className={styles.formGroup}>
                  <Label>
                    <Clock size={14} /> Open At
                  </Label>
                  <Input
                    type="time"
                    value={newEntry.openAt}
                    onChange={(e) => handleNewEntryChange("openAt", e.target.value)}
                  />
                </FormGroup>
              </Col>
              <Col md={3}>
                <FormGroup className={styles.formGroup}>
                  <Label>
                    <Clock size={14} /> Close At
                  </Label>
                  <Input
                    type="time"
                    value={newEntry.closedAt}
                    onChange={(e) => handleNewEntryChange("closedAt", e.target.value)}
                  />
                </FormGroup>
              </Col>
            </>
          )}
          <Col md={1}>
            <Button className={styles.addButton} color="primary" onClick={addWorkingHour}>
              <Plus size={18} />
            </Button>
          </Col>
        </Row>
      </div>

      <div className={styles.workingHoursList}>
        {workingHours.map((entry, index) => (
          <Row key={index} className={styles.workingHourRow}>
            <Col md={3}>
              <Label className={styles.dayLabel}>{entry.day}</Label>
            </Col>
            <Col md={2} className={styles.checkboxContainer}>
              <Input type="checkbox" checked={entry.isClosed} disabled />
              <Label className={styles.closedLabel}>Closed</Label>
            </Col>
            {!entry.isClosed && (
              <>
                <Col md={3}>
                  <Input type="time" value={entry.openAt} disabled className={styles.disabledInput} />
                </Col>
                <Col md={3}>
                  <Input type="time" value={entry.closedAt} disabled className={styles.disabledInput} />
                </Col>
              </>
            )}
            <Col md={1}>
              <Button className={styles.deleteButton} color="danger" onClick={() => removeWorkingHour(index)}>
                <Trash2 size={18} />
              </Button>
            </Col>
          </Row>
        ))}
      </div>
    </div>
  );
};

export default WorkingHoursForm;
